/* eslint-disable @typescript-eslint/no-unused-vars */
import { gql, useQuery } from '@apollo/client';
import React, { FC, useEffect, useState } from 'react';
import StockistCard from './StockistCard';
import { Byline, Spacer, Tagline } from './Type';
import { ReactComponent as IconRightArrow } from '../assets/icons/right-arrow.svg';
import Button from './Button';
import { queryString } from '../utils/queryString';

interface NearestProps {
    lat: number;
    lng: number;
    brand?: string;
    product?: string;
    setLoading: any;
    handleReset: any;
    searchType?: 'GEO' | 'SEARCHED' | 'AREA' | 'DEFAULT';
}

const GET_MARKER = gql`
    query GetMarkers($lat: Float!, $lng: Float!, $brand: ID, $product: ID) {
        settings: siteSettings {
            siteConfig {
                stockistRange
            }
        }
        stockist: stockists(
            where: {
                location: { lat: $lat, lng: $lng }
                product: { brand: $brand, product: $product }
                status: PUBLISH
            }
            first: 1
        ) {
            edges {
                node {
                    id
                    databaseId
                    title
                    stockistMeta {
                        stockistId
                        stockistType
                        stockistAddress
                        stockistAddress2
                        stockistAddress3
                        stockistCounty
                        stockistPostcode
                        stockistTelephoneNumber
                        stockistTown
                        stockistLocation {
                            latitude
                            longitude
                        }
                    }
                }
                distance(lat: $lat, lng: $lng)
            }
        }
        stockistCount: stockists(
            where: {
                location: { lat: $lat, lng: $lng }
                product: { brand: $brand, product: $product }
                status: PUBLISH
            }
            first: 500
        ) {
            nodes {
                databaseId
            }
        }
    }
`;

// TODO reenable product when we have the data
const Nearest: FC<NearestProps> = ({ lat, lng, brand, product, setLoading, searchType, handleReset }) => {
    const { loading, error, data } = useQuery(GET_MARKER, {
        variables: {
            lat,
            lng,
            brand,
            product,
        },
    });

    useEffect(() => {
        setLoading(loading);
    }, [loading, setLoading]);

    const handleGotoMap = () => {
        window?.dataLayer?.push({
            event: 'gtmClick',
            element: {
                category: 'find a stockist',
                name: 'product widget - show all stockists', // set as constant even if the element text changes
                text: 'Show all stockists', // click text of the element clicked
            },
        });

        const pagePath = window.location.pathname;

        window?.dataLayer?.push({
            event: 'find_a_stockist',

            action: 'search',
            page_path: pagePath,
        });

        const query: any = {};

        if (lat) {
            query.lat = lat;
        }
        if (lng) {
            query.lng = lng;
        }
        if (brand) {
            query.brandID = brand;
        }
        if (product) {
            query.productID = product;
        }
        if (searchType) {
            query.searchType = searchType;
        }

        window.location.href = `/stockists/map?${queryString(query)}`;
        // window.location.href = `/stockists/map?lat=${lat}&lng=${lng}&brandID=${brand}&productID=${product}&searchType=${searchType}`;
    };

    return (
        <>
            <Tagline>Your nearest stockist is:</Tagline>

            {!loading && !error && data?.stockist && data.stockist.edges.length >= 1 && (
                <StockistCard stockist={data.stockist.edges[0].node} distance={data.stockist.edges[0].distance} />
            )}

            {!loading && !error && data?.stockistCount && data?.stockistCount.nodes.length >= 2 ? (
                <Byline>
                    There are {data?.stockistCount.nodes.length - 1} or more stockists within {data?.settings?.siteConfig.stockistRange}{' '}
                    miles of your location.
                </Byline>
            ) : (
                <>
                    <Byline>Sorry we could not find any stockists near you</Byline>
                    <Spacer />
                    <Button label="Search Again" onClick={handleReset} />
                </>
            )}

            {!loading && !error && data?.stockist && (
                <>
                    <Spacer />
                    <Button label="Show all stockists" icon={<IconRightArrow />} onClick={handleGotoMap} />
                </>
            )}
        </>
    );
};

export default Nearest;
